module HistoryTableFactory {
  export function GetByColumn(columnId: string, rowId: number, callback: (tableHtml: string) => any): void {
    $.ajax(`/Api/Orm/History/Column?columnId=${columnId}&rowId=${rowId}`,
      {
        success: callback
      }
    );
  }

  export function GetByTable(tableId: string, rowId: number, callback: (tableHtml: string) => any): void {
    $.ajax(`/Api/Orm/History/Table?tableId=${tableId}&rowId=${rowId}`,
      {
        success: callback
      }
    );
  }
}